import type { CouponStatus } from '@mypoz/shared';
import { STATUS_TONES } from '@mypoz/shared';
import { useTranslation } from '@mypoz/i18n';
import { StatusChip } from '@mypoz/ui';

export interface CouponStatusChipProps {
  status: CouponStatus;
}

/**
 * Same dot-and-label recipe as `PackageStatusChip`/`OrderStatusChip`, so every status list in the
 * app reads as one visual language. `valid` is the one state coloured — brand red, the mentor
 * mockup's own accent for a usable coupon — while `scheduled`, `used` and `expired` all read as
 * muted, since none of them can be applied to an order today; only the label distinguishes them.
 *
 * `scheduled` is muted rather than coloured on purpose (MYP-73). A coupon whose window has not
 * opened is a promise, not an offer, and colouring it the same as a usable one would send a
 * customer to the order screen to find out it isn't.
 */
export function CouponStatusChip({ status }: CouponStatusChipProps) {
  const { t } = useTranslation();

  return (
    <StatusChip tone={STATUS_TONES.coupon[status]}>{t(`coupons.status.${status}`)}</StatusChip>
  );
}
